document.addEventListener("DOMContentLoaded", () => {

    const statistikElement = document.querySelector('.teaser-row.statistik .statistik-row');
    if (!statistikElement) return;

    // Delay before animation starts
    const animationDelay = 0;
// How long you want the animation to take, in ms
    const animationDuration = 3000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
    const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
    const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
    const easeOut = t => Math.sqrt(1 - Math.pow(t - 1, 2));

// The animation function, which takes an Element
    const animateCountUp = el => {
        let frame = 0;
        const countTo = parseInt(el.dataset.value.replace('.', ''), 10);
        const countToDisplay = countTo.toLocaleString('de-DE');
        const countToDots = countToDisplay.match(/\./g)?.length ?? 0;
        // Start the animation running 60 times per second
        const counter = setInterval(() => {
            frame++;
            // Calculate our progress as a value between 0 and 1
            // Pass that value to our easing function to get our
            // progress on a curve
            const progress = easeOut(frame / totalFrames);
            // Use the progress value to calculate the current count
            const currentCount = Math.round(countTo * progress);

            // If the current count has changed, update the element
            if (parseInt(el.innerHTML.replace('.', ''), 10) !== currentCount) {
                const currentCountDisplay = currentCount.toLocaleString('de-DE');
                const currentCountDots = currentCountDisplay.match(/\./g)?.length ?? 0;
                const dots = countToDots - currentCountDots;
                const zeroes = countToDisplay.length - currentCountDisplay.length - dots;
                const placeholder = '0'.repeat(zeroes) + '.'.repeat(dots);
                el.innerHTML = `${currentCountDisplay}<span>${placeholder}</span>`;
            }

            // If we’ve reached our last frame, stop the animation
            if (frame === totalFrames) {
                clearInterval(counter);
            }
        }, frameDuration);
    };

// Run the animation on all elements with a class of ‘countup’
    const runCountUp = (el) => {
        el.innerHTML = '0';
        setTimeout(() => animateCountUp(el), animationDelay);
    };

    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                try {
                    runCountUp(entry.target);
                } catch (e) {
                    entry.target.innerHTML = entry.target.dataset.value;
                }
            }
        })
    })

    const countupEls = document.querySelectorAll('.teaser-row.statistik .statistik-value');
    countupEls.forEach(element => intersectionObserver.observe(element));
})